import React from "react";

function Footer() {
  return (
    <div className="footer">
      <p>
        ©Design and Developed by{" "}
        <a target="_blank" href="https://komalkumar.netlify.app/">
          Komal Kumar
        </a>
      </p>
    </div>
  );
}

export default Footer;
